import { isNativeAddress } from '@spritz-finance/sdk'
import { BigNumber, Contract } from 'ethers'
import { useMemo } from 'react'
import { Maybe, TokenBalance } from '../../../../../graphql/generated/graphql'
import { useWeb3Connection } from '../../../../../web3/Web3Provider'
import { ERC20Interface } from '../../../../../web3/hooks/interfaces'

export const useERC20Balance = (token: Maybe<TokenBalance>) => {
    const { account, provider } = useWeb3Connection()
    const validErc20Token = !!token?.address && !isNativeAddress(token.address)

    const contract = useMemo(
        () => (validErc20Token ? new Contract(token?.address, ERC20Interface, provider) : null),
        [validErc20Token, token?.address, provider]
    )

    const getTokenBalance = async () => {
        if (isNativeAddress(token!.address) && account) {
            return provider?.getBalance(account) ?? BigNumber.from(0)
        }
        if (!contract) return BigNumber.from(0)
        const balance: BigNumber = await contract.balanceOf(account)
        return balance ?? BigNumber.from(0)
    }

    return getTokenBalance
}
